var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "selection",
      class: [
        _vm.tab,
        {
          isSGM: !!_vm.isSGM,
          isLive: _vm.isLive,
          priceUp: _vm.priceUp,
          priceDown: _vm.priceDown,
          hcpUp: _vm.hcpUp,
          hcpDown: _vm.hcpDown,
          isClosed: _vm.isClosed,
          isSuspended: _vm.isSuspended,
          edit: _vm.currentBetSlipState == 0,
          review: _vm.currentBetSlipState == 1
        }
      ]
    },
    [
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column column-left" }, [
          _vm.currentBetSlipState < 1
            ? _c(
                "button",
                { staticClass: "btnX", on: { click: _vm.removeSelection } },
                [_c("icon", { attrs: { name: "icon-trash-grey" } })],
                1
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "column column-right" }, [
          _c("label", { attrs: { for: _vm.id } }, [
            _c("div", { staticClass: "selection-data" }, [
              _c("div", { staticClass: "selection-name" }, [
                _c("span", { staticClass: "name" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.selectionName) +
                      "\n                   "
                  ),
                  _vm.selection &&
                  typeof _vm.selection.currenthandicap == "number"
                    ? _c(
                        "span",
                        {
                          staticClass: "currenthandicap",
                          class: [
                            { hcpUp: _vm.hcpUp },
                            { hcpDown: _vm.hcpDown }
                          ]
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.handicap))])]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.isClosed || _vm.isSuspended
                  ? _c(
                      "div",
                      {
                        staticClass: "selection-price float-right",
                        class: "pricetype-" + _vm.pricetype
                      },
                      [
                        _c("span", { staticClass: "price" }, [
                          _vm.isClosed
                            ? _c("span", { staticClass: "price_title" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("BetSlip.selection.isClosed"))
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isSuspended
                            ? _c("span", { staticClass: "price_title" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("BetSlip.selection.isSuspended")
                                  )
                                )
                              ])
                            : _vm._e()
                        ])
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "market-name" }, [
                _vm._v(_vm._s(_vm.marketName))
              ])
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c3423b3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c3423b3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslipV2/selections/selectionSGM.vue
// module id = null
// module chunks = 